export default "__VITE_ASSET__D_Md9fCZ__"